import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-medical-tourism',
  templateUrl: './medical-tourism.component.html',
  styleUrls: ['./medical-tourism.component.css']
})
export class MedicalTourismComponent implements OnInit {

  constructor(private auth:AuthService,private toaster:ToastrService) { }
  tourism:any={
    medicalRecords:[],
    countryCode:'91'
  }

  ngOnInit() {
  this.auth.currentMessage.subscribe(message=>{
    
    this.tourism={
      medicalRecords:[],
      countryCode:localStorage.getItem('logindata') ? JSON.parse(localStorage.getItem('logindata'))['countryCode'] : '91',
      phoneNo:localStorage.getItem('logindata') ? JSON.parse(localStorage.getItem('logindata'))['phoneNo'] : ''
    }
  })
  }
  fileChanged(event) {
    this.auth.fileUpload(event.target.files[0]).subscribe(res => {
        this.tourism.medicalRecords.push(res['data']['original'])
      },
      error => {
        this.toaster.error('There was some error...', 'Error',{
          timeOut: 2000
        });
      })
  }
  hasError(event){

  }
  uploadTourism(form:NgForm){
if(form.valid){
    this.auth.applyMedicalTourism(this.tourism).subscribe(res=>{
      console.log(res)
      this.toaster.success('Successful','Success',{
        timeOut:2000
      })
      form.resetForm()
      this.tourism={
        medicalRecords:[],
        countryCode:localStorage.getItem('logindata') ? JSON.parse(localStorage.getItem('logindata'))['countryCode'] : '91',
        phoneNo:localStorage.getItem('logindata') ? JSON.parse(localStorage.getItem('logindata'))['phoneNo'] : ''
      }
      document.getElementById('medicalTourismTrigger').click()
    },error=>{
      this.toaster.error(error.error.message, 'Error',{
        timeOut: 2000
      });
    })
  }
  }
  resetForm(form:NgForm){
    form.resetForm()
    this.tourism={
      medicalRecords:[],
      countryCode:localStorage.getItem('logindata') ? JSON.parse(localStorage.getItem('logindata'))['countryCode'] : '91',
      phoneNo:localStorage.getItem('logindata') ? JSON.parse(localStorage.getItem('logindata'))['phoneNo'] : ''
    }
  }
  numberOnly(event, id): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
   
    return true;

  }

  onCountryChangeTourism(event){
    console.log(event.dialCode)
    this.tourism.countryCode=event.dialCode
  }

}
